import classnames from 'classnames';
import Image from 'components/Image';
import React, { useMemo } from 'react';

const CSS = require('./RoundedAvatar.module.scss');

interface RoundedAvatarProps {
  image: string;
  color?:
    | 'white'
    | 'pink'
    | 'pink-100'
    | 'yellow'
    | 'purple'
    | 'green'
    | 'orange'
    | 'red'
    | 'none';
  depth?: 1 | 2 | 3;
  thumb?: boolean;
  size?: number;
  height?: number;
  animate?: boolean;
  className?: any;
  alt?: string;
  loading?: 'eager' | 'lazy';
  borderSize?: number;
  testId?: string;
}

function RoundedAvatar({
  image,
  color = 'white',
  depth,
  thumb,
  size = 56,
  height,
  animate = true,
  className,
  alt,
  loading,
  borderSize = 2,
  testId,
}: RoundedAvatarProps) {
  const classes = classnames(CSS.RoundedAvatar, {
    [className]: className,
  });

  const options = useMemo(() => {
    const sizes = {
      width: size - borderSize,
      height: height ? height - borderSize : size - borderSize,
    };
    if (thumb) {
      return {
        crop: 'thumb',
        gravity: 'faces',
        zoom: '0.8',
        ...sizes,
      };
    }
    return sizes;
  }, [size, thumb, height, borderSize]);

  return (
    <div
      data-test-id={testId}
      className={classes}
      style={{
        width: options.width,
        height: options.height,
        borderWidth: `${borderSize}px`,
      }}
      data-variant={color}
      data-depth={depth}
    >
      <Image
        src={image}
        width={options.width}
        height={options.height}
        options={options}
        alt={alt ? 'User image' : alt}
        className={CSS.Avatar}
        animate={animate}
        loading={loading}
      />
    </div>
  );
}

export default RoundedAvatar;
